import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

export const recentTranslationsStateSegment = stateSegmentWithReset<
  Record<string, Record<string, string[]>>
>({});

recentTranslationsStateSegment.debugLabel = 'recentTranslationsStateSegment';
